package nl.appstuff.padelchecker.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.core.Page
import nl.appstuff.padelchecker.site.PageSeo
import nl.appstuff.padelchecker.site.StructuredData
import nl.appstuff.padelchecker.site.components.NavBar
import nl.appstuff.padelchecker.site.localization.LocalSiteLanguage
import nl.appstuff.padelchecker.site.localization.LocalSiteStrings
import nl.appstuff.padelchecker.site.localization.SiteStrings
import org.jetbrains.compose.web.css.vh
import nl.appstuff.padelchecker.site.components.sections.*

@Page
@Composable
fun IndexPage() {
    val strings = LocalSiteStrings.current
    val language = LocalSiteLanguage.current
    PageSeo(
        title = strings.homeSeoTitle,
        description = strings.homeSeoDescription,
        canonicalPath = "/",
        lang = language.tag,
    )
    HomeStructuredData(strings, language.tag)

    Column(modifier = Modifier.fillMaxWidth().minHeight(100.vh)) {
        NavBar()
        HeroSection()
        HowItWorksSection()
        UpcomingSection()
        FaqSection()
//        PricingSection()
        FooterSection()
    }
}

@Composable
private fun HomeStructuredData(strings: SiteStrings, langTag: String) {
    StructuredData(
        """
        [
          {
            "@context": "https://schema.org",
            "@type": "SoftwareApplication",
            "name": "Padelchecker",
            "operatingSystem": "iOS, Android, Web",
            "applicationCategory": "SportsApplication",
            "description": "${strings.homeAppDescription}",
            "url": "https://padelchecker.nl",
            "offers": {
              "@type": "Offer",
              "price": "0",
              "priceCurrency": "EUR",
              "description": "${strings.homeOfferDescription}"
            },
            "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": "5",
              "ratingCount": "5"
            },
            "downloadUrl": [
              "https://apps.apple.com/nl/app/padelchecker-nl-padelbanen/id6759914204",
              "https://play.google.com/store/apps/details?id=nl.appstuff.padelchecker"
            ],
            "inLanguage": "$langTag",
            "author": {
              "@type": "Organization",
              "name": "Appstuff",
              "url": "https://padelchecker.nl"
            }
          },
          {
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "Padelchecker",
            "url": "https://padelchecker.nl/site/",
            "description": "${strings.homeWebsiteDescription}",
            "inLanguage": "$langTag",
            "potentialAction": {
              "@type": "SearchAction",
              "target": "https://padelchecker.nl/zoeken?q={search_term_string}",
              "query-input": "required name=search_term_string"
            }
          },
          {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "${strings.homeFaq1Question}",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "${strings.homeFaq1Answer}"
                }
              },
              {
                "@type": "Question",
                "name": "${strings.homeFaq2Question}",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "${strings.homeFaq2Answer}"
                }
              },
              {
                "@type": "Question",
                "name": "${strings.homeFaq3Question}",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "${strings.homeFaq3Answer}"
                }
              },
              {
                "@type": "Question",
                "name": "${strings.homeFaq4Question}",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "${strings.homeFaq4Answer}"
                }
              },
              {
                "@type": "Question",
                "name": "${strings.homeFaq5Question}",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "${strings.homeFaq5Answer}"
                }
              },
              {
                "@type": "Question",
                "name": "${strings.homeFaq6Question}",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "${strings.homeFaq6Answer}"
                }
              },
              {
                "@type": "Question",
                "name": "${strings.homeFaq7Question}",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "${strings.homeFaq7Answer}"
                }
              }
            ]
          }
        ]
        """.trimIndent()
    )
}
